import React, { useEffect } from 'react';

import DropDown from '../../../Reutilizaveis/DropDown';

// import { ContextSolicitacoes } from "../../../../services/solicitacoes";

export const TiposSolicitacao = ({
  getTipoSolicitacoes,
  setTipoAtendimentoSolicitacao,
  listaTipoSolicitacoes,
  setListaTipoSolicitacoes,
  mensagemErroPodeOuNaoSolicitar,
  imovelSolicitacao,
}) => {
  // const { imovelSolicitacao } = useContext(ContextSolicitacoes);

  // para o dropdown funcionar é necessário criar um objeto que tenha id e nome pelo menos
  async function loadTipoSolicitacoes() {
    let tipoSolicitacoes = '';
    let listTipoSolicitacoes = [];

    try {
      tipoSolicitacoes = await getTipoSolicitacoes();
      console.log('tipoSolicitacao', tipoSolicitacoes);
      tipoSolicitacoes?.forEach((solicitacao) => {
        if (solicitacao.tipo != 'Outros' && solicitacao.geraSolicitacao == 1)
          listTipoSolicitacoes.push({
            id: solicitacao.tipo,
            nome: solicitacao.tipo,
            tipoSolicitacaoIdSalesForce: solicitacao.tipoSalesForce,
            GeraAgendamento: solicitacao.geraAgendamento,
          });
      });
    } catch (error) {
      return error;
    }
    setListaTipoSolicitacoes(listTipoSolicitacoes);
  }

  useEffect(() => {
    (async function () {
      await loadTipoSolicitacoes();
    })();
  }, []);

  console.log('imovelSolicitacao', imovelSolicitacao);

  return (
    <>
      {imovelSolicitacao && (
        <div className='novaSolicitacao__info'>
          <DropDown
            itens={listaTipoSolicitacoes}
            idDropDown={'ListaSolicitacoes'}
            setValue={setTipoAtendimentoSolicitacao}
            label='Tipo de atendimento'
            nomeDropDown='Selecione aqui o assunto desejado.'
            obrigatorio='true'
            widthMeuImovel='100% '
            marginLeftMeuImovel='0px'
            error={mensagemErroPodeOuNaoSolicitar}
          />
        </div>
      )}
    </>
  );
};

export default TiposSolicitacao;
